// ---------------------------------------------------------------------------
// RH · Recrutamento — config compartilhada de upload de ARQUIVO. Tipos e
// limite espelham o backend (handoffs 0061 §4.3/§6 e 0065 §5): PDF, JPEG, PNG,
// WEBP, ≤10MB — mesmos limites pro currículo e pros documentos do checklist de
// admissão. Reusado pelo ResumeFact (ficha), cadastro de candidato e checklist (F1).
// ---------------------------------------------------------------------------

export const UPLOAD_ACCEPTED_MIME_TYPES =
   'application/pdf,image/jpeg,image/png,image/webp';

export const UPLOAD_MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024; // 10MB

// Valida um File client-side. Retorna a mensagem de erro (string) ou null se OK.
export function validateUploadFile(file) {
   if (!file) return null;
   if (file.size > UPLOAD_MAX_FILE_SIZE_BYTES) {
      return 'Arquivo muito grande. O limite é 10MB.';
   }
   return null;
}

// Aliases legados (nomes da Fase 0, quando o upload era só de currículo) —
// consumidores existentes seguem funcionando; código novo usa os genéricos.
export const RESUME_ACCEPTED_MIME_TYPES = UPLOAD_ACCEPTED_MIME_TYPES;
export const RESUME_MAX_FILE_SIZE_BYTES = UPLOAD_MAX_FILE_SIZE_BYTES;
export const validateResumeFile = validateUploadFile;
